import project1 from "./assets/images/qxtro-python-staging.herokuapp.com.png";
import project2 from "./assets/images/www.archetape.com.jpg";
import project3 from "./assets/images/www.assured.claims.png";
import project4 from "./assets/images/www.modzy.com.png";
import project8 from "./assets/images/www.loungebuddy.com.png";
import project9 from "./assets/images/pleroma.social.png";
import project10 from "./assets/images/campusoptics.png";
import project13 from "./assets/images/omniscience.png";
import project14 from "./assets/images/intellimize.png";
import project15 from "./assets/images/laurelroad.png";
import project16 from "./assets/images/sparkrock.png";
import project17 from "./assets/images/depinninja.png";
import project18 from "./assets/images/lunarcrush.png";
import project19 from "./assets/images/orthogonal.png";

export const skills = [
    { type: "React.js", level: 98, expertise: 'Expert', years: 8 },
    { type: "React Native", level: 95, expertise: 'Expert', years: 7 },
    { type: "JavaScript", level: 98, expertise: 'Expert', years: 12 },
    { type: "TypeScript", level: 98, expertise: 'Expert', years: 8 },
    { type: "Next.js", level: 95, expertise: 'Expert', years: 6 },
    { type: "Python", level: 98, expertise: 'Expert', years: 6 },
    { type: "Flutter", level: 98, expertise: 'Expert', years: 6 },
    { type: "Web3.js", level: 90, expertise: 'Expert', years: 4 },
    { type: "Machine Learning", level: 90, expertise: 'Expert', years: 8 },
    { type: "Frontend Development", level: 96, expertise: 'Expert', years: 12 },
    { type: "Backend Development", level: 92, expertise: 'Advanced', years: 8 },
    { type: "LLM", level: 92, expertise: 'Advanced', years: 5 },
    { type: "Blockchain Development", level: 98, expertise: 'Expert', years: 6 },
    { type: "GraphQL", level: 95, expertise: 'Expert', years: 6 },
    { type: "Redux", level: 98, expertise: 'Expert', years: 7 },
    { type: "Angular", level: 88, expertise: 'Expert', years: 6 },
    { type: "Vue.js", level: 88, expertise: 'Expert', years: 6 },
    { type: "Node.js", level: 85, expertise: 'Expert', years: 8 },
    { type: "Django", level: 98, expertise: 'Expert', years: 8 },
    { type: "FastAPI", level: 98, expertise: 'Expert', years: 8 },
    { type: "Nuxt.js", level: 88, expertise: 'Expert', years: 5 },
    { type: "ES6+", level: 98, expertise: 'Expert', years: 7 },
    { type: "Tailwind CSS", level: 95, expertise: 'Expert', years: 5 },
    { type: "Styled-Components", level: 98, expertise: 'Expert', years: 7 },
    { type: "HTML/HTML5", level: 98, expertise: 'Expert', years: 10 },
    { type: "CSS/CSS3", level: 98, expertise: 'Expert', years: 10 },
    { type: "MERN", level: 98, expertise: 'Expert', years: 7 },
    { type: "MEAN", level: 98, expertise: 'Expert', years: 6 },
    { type: "AWS", level: 85, expertise: 'Advanced', years: 8 },
    { type: "Firebase", level: 90, expertise: 'Expert', years: 7 },
    { type: "Azure", level: 85, expertise: 'Advanced', years: 6 },
    { type: "C#", level: 85, expertise: 'Advanced', years: 8 },
    { type: "ASP.NET/.NET Core", level: 85, expertise: 'Advanced', years: 8 },
    { type: "jQuery", level: 98, expertise: 'Expert', years: 10 },
    { type: "Bootstrap", level: 98, expertise: 'Expert', years: 10 },
    { type: "Webflow", level: 92, expertise: 'Expert', years: 5 },
    { type: "MongoDB", level: 92, expertise: 'Expert', years: 8 },
    { type: "WordPress", level: 78, expertise: 'Skilled', years: 6 },
    { type: "MySQL", level: 75, expertise: 'Skilled', years: 8 },
    { type: "PHP/Laravel", level: 98, expertise: 'Expert', years: 7 },
];

export const sections = [
    {
        href: "#about",
        name: "About",
    },
    {
        href: "#experience",
        name: "Experience",
    },
    {
        href: "#projects",
        name: "Projects",
    },
];

export const projects = [
    {
      name: "Orthogonal",
      year: 2025,
      appName: "Bright Uro",
      description: `- Led the development of complex healthcare web applications using React.js, Next.js, and TypeScript, ensuring scalability, performance, and accessibility.
      - Built rich data visualization dashboards with D3.js and Echarts, transforming large medical datasets into actionable insights for clinicians and stakeholders.
      - Designed and implemented responsive UI components with Tailwind CSS, improving usability and consistency across applications.
      - Streamlined development workflows by setting up a CI/CD pipeline with GitHub Actions, reducing release cycle times, and ensuring reliable deployments.
      - Mentored junior developers and introduced best practices in code quality, testing, and performance optimization.
      - Built and deployed a cross-platform React Native app with Expo and TypeScript, delivering a reliable and performant mobile experience for Bright Uro’s urology diagnostic platform.
      - Integrated advanced features such as OCR for medical document processing and FDA-compliant login flows, ensuring regulatory compliance and secure data handling.
      - Designed and implemented UI components with a consistent design system across React Native and React.js applications, improving development efficiency and user experience.
      - Collaborated with backend teams, QA, and clinical experts to align technical delivery with medical industry requirements and user needs.
      `,
      skills: ['React', "TypeScript", "Expo", "React Native", "Flutter", "Next.js", "Python", "Django", "Tailwind CSS", "D3.js", "Echarts", "OCR", "FDA", "CI/CD", "GitHub Actions", "Jest", "React Testing Library", "Dart"],
      duration: "Jan - Sep 2025",
      experience: "Engineered React/React Native applications with TypeScript for a urology diagnostic platform, emphasizing performance and scalability.",
      role: "Senior Frontend Developer (React / React Native)",
      image: project19,
      link: "https://orthogonal.io/",
    },
    {
      name: "LunarCrush",
      year: 2024,
      appName: "LunarCrush",
      description: `- Improved legacy React code based on best practices.
      - Served as a lead front-end developer for improvements and mentored junior developers.
      - Worked with Ethereum, Polygon, and other EVM-compatible chains, including deploying and integrating smart contracts using Solidity, Web3.js, and Ethers.js.
      - Led migrating a large-scale web application from React and Node.js to Next.js and GraphQL, achieving significant performance and maintainability improvements.
      - Provided training and best practices to the development team for working with Next.js and GraphQL.
      - Integrated TensorFlow library for models to predict user behavior and offer personalized recommendations on a content platform.
      - Refactored and updated the existing React Native applications for iOS and Android platforms.
      `,
      skills: ['React', "TypeScript", "GraphQL", "React Native", "Next.js", "LLM", "Node.js", "NestJS", "TensorFlow", "Ethereum", "Polygon", "Solana", "Ethers.js", "Web3.js"],
      duration: "Jun - Dec 2024",
      role: "Senior Full-Stack Developer",
      image: project18,
      link: "https://lunarcrush.com/",
    },
    {
      name: "Escape Velocity",
      year: 2024,
      appName: "DePIN Ninja",
      description: `- Developed and maintained a responsive web application using React and Redux to manage state and optimize performance, delivering a seamless user experience across devices.
      - Integrated GraphQL to fetch and manage data, improving the dynamic rendering of content based on user interactions.
      - Employed React Hooks (useState, useEffect) to streamline component logic and improve code maintainability and readability.
      - Utilized React Router for navigation, ensuring smooth, client-side routing and reducing page load times.
      - Optimized performance with code splitting and lazy loading techniques, resulting in faster initial page load and improved user engagement.
      - Wrote unit and integration tests with Jest and React Testing Library, ensuring the stability and reliability of the application.
      - Collaborated closely with UX/UI designers and backend developers to ensure features were delivered on time and aligned with project goals.
      `,
      skills: ['React', "TypeScript", "GraphQL", "React-Material", "Figma", "Responsive Design", "Jest", "React Testing Library", "React Router", "Code Splitting", "Lazy Loading"],
      duration: "Oct 2023 - Jun 2024",
      role: "Full-Stack Developer for Open Source Crypto Analytics Site",
      image: project17,
      link: "https://depin.ninja",
    },
    {
      name: "Sparkrock",
      year: 2023,
      appName: "My Sparkrock Employee Web App",
      description: `- Worked on updating web frontend pages with Angular10, TypeScript, Bootstrap, LESS/CSS, etc.
      - Implemented pixel-perfect and mobile-friendly Figma designs.
      - Worked on updating tables in Microsoft 365.
      - Integrated backend APIs built with .Net Core.        
      `,
      skills: ['Angular10', "TypeScript", "LESS", "Bootstrap", "Figma", ".Net Core", "Microsoft 365", "Microsoft Graph API", "Microsoft Teams API"],
      duration: "Mar - Aug 2023",
      role: "Frontend Engineer",
      image: project16,
      link: "https://gigster.mysparkrock.com",
    },
    {
      name: "Laurel Road",
      year: 2022,
      appName: "Web apps for personal and students loans",
      description: `- Refactored a very large codebase based on the best practices.
      - Migrated a React project from Reflux to Redux.
      - Cleaned up the entire project based on best practices.
      - Created new custom hooks and implemented pixel-perfect Figma design.
      - Worked on updating the npm library for UI components.
      `,
      experience: "Add features into the web applications for personal and students loans and refactored multiple projects without a massive rewrite based on best practices",
      skills: ['React', "Redux", "Ruby on Rails", "Styled-Components", "Figma", "React Hooks", "Jest", "React Testing Library", "React Router", "Code Splitting", "Lazy Loading"],
      duration: "Feb 2022 - Jan 2023",
      role: "Senior Front-End Developer",
      image: project15,
      link: "https://www.laurelroad.com/welcome-personal-loan",
    },
    {
      name: "Intellimize",
      appName: "AI-driven Optimization Web App",
      year: 2021,
      description: `- Worked on building Editor App with React.js, Redux, Redux-Saga, TypeScript, Jest, D3.js, Lodash, etc.
      - Implemented pixel-perfect Figma designs and added new functionalities.
      - Worked on fixing lint issues and wrote unit tests with Jest and Mocha/Chai
      - Created new hooks for cleaning up the codebase and updated basic components like a tooltip, select, collapsible card, and modal with new props for adding more features.
      `,
      skills: ["React", "Redux", "Redux-Saga", "TypeScript", "Jest", "D3.js", "Lodash", "Figma", "Next.js", "React Hooks", "React Testing Library"],
      role: "Frontend Developer",
      image: project14,
      link: "https://www.intellimize.com",
    },
    {
      name: "OmniScience",
      appName: "Admin Dashboard for Employees",
      year: 2021,
      description: `- Worked on building an admin dashboard with React, GraphQL, Apollo, and React-Material-UI.
      - Implemented pixel-perfect Figma Designs.
      - Integrated AWS services like DynamoDB, AppSync, Cognito, S3, etc.
      - Wrote GraphQL mutations/queries/subscriptions with AppSync Resolver and integrated them with Admin Dashboard.    
      `,
      skills: ["React", "GraphQL", "Apollo", "Material-UI", "Figma", "Next.js", "DynamoDB", "AWS Cognito", "AWS AppSync", "Jest", "React Testing Library"],
      role: "React Full-Stack Developer",
      image: project13,
      link: "https://omniscience.com",
    },
    {
      name: "CivImpact Labs",
      appName: "Video Conference Web App",
      year: 2021,
      description: `- Built a single page application with React, Redux, TypeScript, HTML5, CSS3, SCSS, Opentok API, etc.
      - Implemented pixel-perfect and mobile-friendly Figma Designs.
      - Worked on implementing the Video/Audio conference features with OpenTok and WebSocket APIs.
      - Worked on integrating REST APIs with Axios and Redux-Thunk
      `,
      skills: ["React", "Redux", "TypeScript", "HTML5", "CSS3", "SCSS", "Opentok API", "Figma", "Redux-Thunk", "Video Conference", "Jest", "React Testing Library"],
      role: "Senior Frontend Developer",
      image: project1,
      link: "https://qxtro-python-staging.herokuapp.com",
    },
    {
        name: "Modzy",
        year: 2021,
        appName: "Admin Dashboard for developers and data scientists",
        description: `- Built an admin dashboard for Modzy using React.js, GraphQL, Apollo, ES6, HTML5, CSS3, SCSS, D3.js, etc.
        - Implemented pixel-perfect Invision Design
        - Implemented several complex charts for data visualization using D3.js
        - Worked on integrating GraphQL queries and mutations
        `,
        experience: "Mostly focused on implementing components library to be used in the entire project and implemented tons of complex charts for data visualization using D3.js",
        skills: ["React", "React-Query", "GraphQL", "Apollo", "HTML5", "CSS3", "SCSS", "D3.js", "Data Visualization", "Jest", "React Testing Library"],
        duration: "Feb - May 2021",
        role: "Senior Frontend React Developer",
        image: project4,
        link: "https://www.modzy.com",
      },
    {
      name: "ArcheTape",
      appName: "Web and Mobile Applictions for SaaS Real Estate Product",
      year: 2020,
      description: `- Built responsive web front-end pages and implemented mobile-friendly and pixel-perfect figma designs with React.js, Redux, HTML5, CSS3, and styled-components.
      - Delivered a marketing website with React.js, HTML5, CSS3, and styled-components.
      - Built cross-platform mobile apps for iOS and Android platforms with React Native CLI, React, Redux, Redux-Thunk, and Axios.
      - Integrated several third-party React and React Native packages such as Google Mapbox, DnD, and Stripe payment.
      - Implement messaging functionality with SendBird API and integrated FCM for push notification.
      `,
      skills: ["React", "Redux", "React Native", "TypeScript", "HTML5", "CSS3", "SCSS", "Stripe", "Google Mapbox", "SendBird API", "Push Notifications", "Jest", "React Testing Library"],
      role: "Senior Frontend Developer",
      image: project2,
      link: "https://www.archetape.com",
    },
    {
      name: "Assured Insurance",
      appName: "Marketing Website for Assure Claims",
      year: 2020,
      description: `- Built a Webflow website using Webflow CMS, Webflow UIKit, JavaScript, jQuery, HTML, CSS, etc.
      - Implemented mobile-friendly and pixel-perfect UI based on the Figma designs
      - Implemented UI animations
      - Integrated Third-Party systems like Maketo Form, Greenhouse, etc.
      `,
      skills: ["Webflow", "JavaScript", "jQuery", "HTML", "CSS", "Maketo From", "Greenhouse", "Email Template", "Animation"],
      role: "Webflow Expert",
      image: project3,
      link: "https://www.assured.claims",
    },
    {
      name: "LoungeBuddy",
      appName: "Web and Mobile Apps to find lounges",
      year: 2019,
      description: `- Built responsive and mobile-friendly web front-end pages with React.js, Redux, HTML, CSS, SASS/SCSS, etc.
      - Worked on migrating Angular to React without a massive rewrite.
      - Integrated Backend API with Redux -Saga and Axios and 3rd party systems like Greenhouse, ZenDesk, Marketo Form, etc
      - Built an iOS app with React Native, React, Redux-Thunk.
      - Designed the entire mobile application to be able to function offline for long periods of time and sync data back once in cell reception (online).
      - Integrated Unit Testing with Jest and Increased testing coverage of the existing application Cypress.
      `,
      skills: ["React", "Angular", "React Native", "Redux", "Redux-Saga", "Redux-Thunk", "Axios", "ZenDesk", "Marketo Form", "Pixel-Perfect", "HTML", "CSS", "Jest", "React Testing Library", "React Router", "Code Splitting", "Lazy Loading"],
      role: "Full-Stack Developer",
      image: project8,
      link: "https://www.loungebuddy.com",
    },
    {
      name: "Pleroma",
      appName: "Social Networking Software",
      year: 2017,
      description: `- Implemented front-end pages with Vue.js , Vuex , Vuetify , HTML5 , CSS3 , Bootstrap. Redesigned, simplified, and implemented a new version of an existing alerting application that contained over 100 form fields and drastically reduced the amount of customer support calls with the simplified redesign.
      - Developed a universal search feature for a customer-facing analytic application that allowed all of the application's data entities to be searched instantly within a single interface.
      - Implemented various private APIs on a Node. js and MongoDB backend.
      `,
      skills: ["Vue.js", "Vuex", "Vuetify", "Vueuse", "HTML5", "CSS3", "Bootstrap", "Node.js", "MongoDB", "Express.js"],
      role: "Full-Stack Developer",
      image: project9,
      link: "https://pleroma.social",
    },
    {
      name: "CampusOptics App",
      appName: "Cross-functional EH&S platform",
      year: 2015,
      description: `- Built a React Native mobile app with React Native CLI, TypeScript, React Navigation, etc.
      - Worked on integrating the Firebase Analytics, Google Maps API, etc`,
      image: project10,
      skills: ["React", "React Native", "TypeScript", "React Navigation", "Firebase", "Google Maps API"],
      role: "Senior React Native Developer",
      link: "https://apps.apple.com/us/app/campusoptics/id1500448331",
    },
  ];
